import React from 'react';

import PropTypes from 'prop-types';

const TagWrapper = React.forwardRef(({ children, tag: Tag, ...props }, ref) => {
	return (
		// eslint-disable-next-line react/jsx-props-no-spreading
		<Tag ref={ref} {...props}>
			{children}
		</Tag>
	);
});
TagWrapper.propTypes = {
	children: PropTypes.node,
	tag: PropTypes.string,
};
TagWrapper.defaultProps = {
	children: null,
	tag: 'div',
};

export default TagWrapper;
